var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-top":"150px","width":"490px","margin":"0 auto"}},[_c('h1',{staticClass:"display-3"},[_vm._v("SORRY PAGE WAS NOT FOUND")])])])
}]

export { render, staticRenderFns }